export default "__VITE_ASSET__BXzr_fOW__"